module.exports = __webpack_public_path__ + "static/media/type-radio.9b68373d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/type-radio.svg
// module id = 106
// module chunks = 0